import { useTranslation } from 'react-i18next';
import styles from './styles';
import { Badge } from './types';

interface VehicleItemBadgesProps {
  badges: Badge[];
}

export default function VehicleItemBadges({ badges }: VehicleItemBadgesProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="outer-container">
      {badges.map((badge: Badge) => (
        <div className={`badge ${badge}`} key={badge}>
          {t(`badges.${badge}`)}
        </div>
      ))}
      <style jsx>{styles}</style>
    </div>
  );
}
